import { render, staticRenderFns, recyclableRender, components } from "./riskDetails.vue?vue&type=template&id=057a0eee&scoped=true&"
var renderjs
import script from "./riskDetails.vue?vue&type=script&lang=js&"
export * from "./riskDetails.vue?vue&type=script&lang=js&"
import style0 from "./riskDetails.vue?vue&type=style&index=0&id=057a0eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a0eee",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/riskDetails/riskDetails.vue"
export default component.exports